var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolygon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13552_12059)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9898 0C40.3558 0 52 11.6442 52 26.0102C52 40.3762 40.3558 52.0102 26 52.0102C11.634 52.0102 6.73837e-06 40.366 6.73837e-06 26.0102C-0.0102255 11.6442 11.634 0 25.9898 0Z",
    fill: "#8247E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13552_12059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 14,
    width: 28,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3875 14H12V38H39.3875V14Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13552_12059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6865 21.3095C32.185 21.0217 31.5436 21.0217 30.9763 21.3095L26.9804 23.6774L24.2672 25.182L20.3453 27.5417C19.8437 27.8295 19.2024 27.8295 18.6351 27.5417L15.5683 25.6754C15.0668 25.3876 14.7132 24.812 14.7132 24.1707V20.5859C14.7132 20.0104 15.001 19.4431 15.5683 19.0813L18.6351 17.2889C19.1366 17.0012 19.778 17.0012 20.3453 17.2889L23.4121 19.1553C23.9136 19.4431 24.2672 20.0186 24.2672 20.6599V23.0279L26.9804 21.4493V19.0155C26.9804 18.44 26.6927 17.8727 26.1253 17.5109L20.4193 14.1399C19.9177 13.8521 19.2764 13.8521 18.7091 14.1399L12.8633 17.5849C12.2959 17.8727 12.0082 18.4482 12.0082 19.0155V25.7494C12.0082 26.3249 12.2959 26.8922 12.8633 27.254L18.6433 30.625C19.1449 30.9128 19.7862 30.9128 20.3535 30.625L24.2754 28.3311L26.9886 26.7524L30.9105 24.4585C31.4121 24.1707 32.0534 24.1707 32.6207 24.4585L35.6875 26.2509C36.1891 26.5387 36.5426 27.1142 36.5426 27.7555V31.3403C36.5426 31.9159 36.2548 32.4832 35.6875 32.8449L32.6947 34.6373C32.1932 34.9251 31.5519 34.9251 30.9845 34.6373L27.9095 32.8449C27.408 32.5572 27.0544 31.9816 27.0544 31.3403V29.0464L24.3412 30.625V32.9929C24.3412 33.5685 24.6289 34.1358 25.1963 34.4976L30.9763 37.8686C31.4779 38.1563 32.1192 38.1563 32.6865 37.8686L38.4666 34.4976C38.9681 34.2098 39.3216 33.6342 39.3216 32.9929V26.1851C39.3216 25.6096 39.0339 25.0423 38.4666 24.6805L32.6865 21.3095Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13552_12059"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/Polygon.48d7719d6f8075d636d6e160bcc4ae0a.svg";
export { ForwardRef as ReactComponent };